import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatPaginator, MatPaginatorModule } from '@angular/material/paginator';
import { MatTableDataSource } from '@angular/material/table';
import { ApproveRedelegation } from '../../../interface/temporaryredelegation/approveredelegation';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MaterialModule } from '../../../shared/module/material.module';
import { CalAngularService } from '@cvx/cal-angular';
import { SharedServices } from '../../../shared/services/shared.services';
import { LookupComponent } from '../../../shared/component/look-up/lookup.component';
import { Observable } from 'rxjs';
import { CommonService } from '../../../services/common/common.service';

@Component({
  selector: 'app-redelegation',
  imports: [FormsModule, CommonModule, MaterialModule, MatPaginatorModule, LookupComponent],
  templateUrl: './redelegation.component.html',
  styleUrls: ['./redelegation.component.css']
})
export class RedelegationComponent implements OnInit, AfterViewInit {
  redelegation!: ApproveRedelegation;
  redelegationHistory = new MatTableDataSource<ApproveRedelegation>();
  displayedColumns: string[] = ['sno', 'toEmpno', 'toName', 'approverCai', 'startDate', 'endDate', 'dueTo'];
  FromEmpno!: string;
  eDate: string = '';
  action: string = 'A';
  comments: string = '';
  selectedSupervisor: string = '';
  loggedUserEmail: string = '';
  isDisable: boolean = false;
  public paginator!: MatPaginator;
  isLoading: boolean = true;
  selectedData: any;
  supervisor: string = '';
  reportsToEmailAddress: string = ''; 
  divisionId: string = '';
  employeeTypeName: string = '';  
  supervisorEmployeeType: string = '';
  supervisorDivisionId: string = '';
  isForward: boolean = false;
  isReject: boolean = false;
  isAlreadyApproved: boolean = false;

  constructor(private route: ActivatedRoute, private router: Router, private redelegationService: TemporaryRedelegationService, private authService: CalAngularService, private sharedService: SharedServices, private commonService: CommonService ) { }

  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  ngOnInit(): void {
    this.loggedUserEmail = this.authService.cvxClaimsPrincipal.userName ?? '';
    this.route.queryParams.subscribe(params => {
      this.FromEmpno = params['FromEmpno'];
      this.eDate = params['eDate'];
      this.fetchRedelegationDetails();
      this.fetchEmployeeDetails();
    });
  }
  ngAfterViewInit(): void {
    this.redelegationHistory.paginator = this.paginator;
  }
  setDataSourceAttributes() {
    if (this.paginator) {
      this.redelegationHistory.paginator = this.paginator;
    }
  }


  fetchRedelegationDetails(): void {
    this.isLoading = true;
  
    this.redelegationService.getRedelegationDetails(this.FromEmpno, this.eDate).subscribe({
      next: data => {
        if (!data) {
          this.isAlreadyApproved = true;
          this.isLoading = false;
          return;
        }
  
        this.redelegation = data;
  
        if (this.loggedUserEmail.trim().toUpperCase() === this.redelegation.approverEmail?.trim().toUpperCase()) {
          this.isDisable = true;
        }
  
        this.redelegationService.getRedelegationHistoryDetails(this.FromEmpno, this.eDate).subscribe(historyData => {
          this.redelegationHistory.data = historyData;
          this.redelegationHistory.paginator = this.paginator;
          this.isLoading = false;
        }, error => {
          this.isLoading = false;
        });
      },
      error: error => {
        this.isAlreadyApproved = true;
        this.isLoading = false;
      }
    });
  }
  
  fetchEmployeeDetails(): void {
    if (this.FromEmpno.length >= 4) {
      this.commonService.getEmployeeDetails(this.FromEmpno).subscribe((response: any) => {
        if (response && Array.isArray(response.value)) {
          const employeeDetails = response.value[0];
          this.selectedSupervisor = employeeDetails?.reportsToEmailAddress;
          this.divisionId = employeeDetails?.divisionID;
          this.employeeTypeName = employeeDetails?.employeeTypeName;
  
          // Call the second API only after the first API call is successful
          if (this.selectedSupervisor) {
            this.commonService.getEmployeeDetails(this.selectedSupervisor).subscribe((supervisorResponse: any) => {
              if (supervisorResponse && Array.isArray(supervisorResponse.value)) {
                const supervisorDetails = supervisorResponse.value[0];
                this.supervisorEmployeeType = supervisorDetails?.employeeTypeName;
              } else {
                this.reportsToEmailAddress = '';
              }
            });
          }
        } else {
          this.reportsToEmailAddress = '';
        }
  
        // Trigger the approver selection after the first API call
        this.onApproverSelected({ emailAddress: this.selectedSupervisor });
      });
    } else {
      this.reportsToEmailAddress = '';
    }
  }
  approveRequest(): void {
    this.action = 'APPROVE';
    this.isLoading = true;
    this.saveRecord().subscribe({
      next: response => {
        this.isLoading = false;
        this.sharedService.openModal('Message', 'Approval successfully submitted!');
        this.router.navigate(['/TemporaryRedelegation/ApproveReDelegation']);
      },
      error: error => {
        console.error('Error approving request', error);
        this.isLoading = false;
      }
    });
  }
  reject(){
    this.isReject = true;
  }
  backReject(){
    this.isReject = false;
  }
  rejectRequest(): void {
    this.action = 'REJECT';
    if (!this.comments) {
      this.sharedService.openModal('Message', 'Reason for Rejecting request is required!');
      return;
    }
    this.isLoading = true;
    this.saveRecord().subscribe({
      next: response => {
        this.isLoading = false;
        this.sharedService.openModal('Message', 'Request was successfully rejected!');
        this.router.navigate(['/TemporaryRedelegation/ApproveReDelegation']);
      },
      error: error => {
        console.error('Error rejecting request', error);
        this.isLoading = false;
      }
    });
  }
  forward(){
    this.isForward = true;
  }
  backForward(){
    this.isForward = false;
  }
  forwardRequest(): void {
    this.action = 'FORWARD';
    if (!this.selectedSupervisor) {
      this.sharedService.openModal('Message', 'Select a Supervisor to Send this request to!');
      return;
    }
    const toEmails = this.redelegationHistory.data.map((item: any) => item.toEmail);
    if (toEmails.includes(this.selectedSupervisor) || this.selectedSupervisor === this.redelegation.fromEmail) {
      this.sharedService.openModal('Message', 'The selected supervisor cannot be the same as <br> the Delegate or the Delegator!');
      return;
    }
    if (this.supervisorEmployeeType !== 'Employee - Permanent' && this.supervisorEmployeeType !== 'Employee - Expat') {
      this.sharedService.openModal('Message', 'The selected supervisor must be a Permanent Employee!');
      return;
    }
    this.isLoading = true;
    this.saveRecord().subscribe({
      next: response => {
        this.isLoading = false;
        this.sharedService.openModal('Message', 'Approval successfully re-routed!');
        this.router.navigate(['/TemporaryRedelegation/ApproveReDelegation']);
      },
      error: error => {
        console.error('Error forwarding request', error);
        this.isLoading = false;
      }
    });
  }

  saveRecord(): Observable<any> {
    const sLogonCAI = this.loggedUserEmail;
    const sDate = new Date();

    return this.redelegationService.saveRedelegationAction(this.FromEmpno, this.action, sLogonCAI, this.eDate, this.comments, this.selectedSupervisor);
  }
  onCancel() {
    history.back();
  }
  onApproverSelected(selectedResult: any): void {
    if(this.reportsToEmailAddress){
      this.selectedSupervisor = this.reportsToEmailAddress;
     }
    else if (selectedResult && selectedResult.emailAddress) {
      this.selectedSupervisor = selectedResult.emailAddress
      this.supervisorEmployeeType = selectedResult.employeeTypeName;
      this.supervisorDivisionId = selectedResult.divisionID;
    }
  }
  formatDate(dateString: string): string {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);
    const options: Intl.DateTimeFormatOptions = {
      weekday: 'short',
      day: '2-digit',
      month: 'short',
      year: 'numeric'
    };
    return date.toLocaleDateString('en-US', options);
  }
  formatDateTo(dateString: string): string {
    if (!dateString) {
      return "";
    }
    const date = new Date(dateString);

    const day = date.getDate().toString().padStart(2, '0');
    const month = date.toLocaleString('default', { month: 'short' });
    const year = date.getFullYear();

    let hours = date.getHours();
    const minutes = date.getMinutes().toString().padStart(2, '0');
    const ampm = hours >= 12 ? 'PM' : 'AM';
    hours = hours % 12;
    hours = hours ? hours : 12;
    const strTime = hours.toString().padStart(2, '0') + ':' + minutes + ' ' + ampm;

    return `${day}-${month}-${year} ${strTime}`;
  }
}
